<template>
  <el-cascader
    :props="props"
    v-model="val"
    :options="options"
    popper-class="area-cascader"
  />
</template>

<script>
import areaJson from '../../../public/area.json'
export default {
  props: ['value'],
  data () {
    return {
      options: areaJson,
      props: {
        value: 'id',
        label: 'name',
        emitPath: false
      }
    }
  },
  computed: {
    val: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss">
// .area-cascader {
//   .el-cascader-node.in-active-path {
//     color: #FB5A4A;
//   }
// }
</style>
